module.exports = __webpack_public_path__ + "img/bindname.abc0d76a.png";